<template>
  <div>
    <v-menu bottom left v-if="group">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-if="group.group_type == 'Premium'"
          color="primary"
          outlined
          v-bind="attrs"
          v-on="on"
          :small="$vuetify.breakpoint.xsOnly"
          :loading="loading"
          class="share-btn"
        >
          <v-icon :small="$vuetify.breakpoint.xsOnly">mdi-dots-vertical</v-icon>
        </v-btn>
        <v-btn
          v-else
          icon
          v-bind="attrs"
          :small="$vuetify.breakpoint.xsOnly"
          v-on="on"
          class="align-self-start"
          :loading="loading"
        >
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>

      <v-list>
        <v-list-item v-if="group.group_type != 'Premium'" @click="shareGroup">
          <v-list-item-title role="button" aria-haspopup="dialog">
            Share
          </v-list-item-title>
        </v-list-item>
        <v-list-item v-if="group.is_participant" @click="openGroup(group)">
          <v-list-item-title role="button"> Leave </v-list-item-title>
        </v-list-item>
        <v-list-item v-if="group.is_participant" @click="reportAndBlock()">
          <v-list-item-title role="button">
            Report & Block User</v-list-item-title
          >
        </v-list-item>
        <v-list-item v-if="group.is_admin" @click="editGroup(group)">
          <v-list-item-title> Edit </v-list-item-title>
        </v-list-item>
        <v-list-item v-if="group.is_admin" @click="deleteGroup(group)">
          <v-list-item-title role="button" aria-haspopup="dialog">
            Delete
          </v-list-item-title>
        </v-list-item>
        <v-list-item
          v-if="group.is_admin"
          @click="toggleFollowerModal({ show: true, group: group.id })"
        >
          <v-list-item-title role="button" aria-haspopup="dialog">
            <span> View Member </span>
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <LeaveGroupModal :openModal="openModal"> </LeaveGroupModal>
    <ReportAndBlockUser> </ReportAndBlockUser>
  </div>
</template>

<script>
// import GroupEditModal from "@/components/GroupEditModal.vue";
import { mapActions } from "vuex";
import commonFunctions from "@/common/commonFunctions";
import Axios from "@/api/BaseAxios";
import newAxios from "@/api/newAxios";
import helper from "@/helper";
import LeaveGroupModal from "@/components/Profile/ProfileTradeDetails/LeaveGroupModal.vue";
import ReportAndBlockUser from "./BlockUser/ReportAndBlockUser.vue";
// import { isAuthenticated } from "@/common/commonFunc";

// import axios from "axios";
export default {
  components: { LeaveGroupModal, ReportAndBlockUser },

  data: () => ({
    loading: false,
    loggedInProfile: {},

    commonFun: commonFunctions,
    openModal: {
      flag: false,
      group: {},
    },
  }),

  computed: {
    group() {
      return this.$store.state.groups.group;
    },
  },

  methods: {
    ...mapActions({
      toggleGroupModal: "group/toggleShowGroupModal",
      isParticipantToggle: "groups/setGroupAfterJoin",
      toggleFollowerModal: "group/toggleFollowerModal",
      toggleBlockUser: "blockUser/toggleModal",
    }),

    openGroup(group) {
      this.openModal.flag = true;
      console.log(this.group);
      this.openModal.group = group;
    },
    reportAndBlock() {
      this.toggleBlockUser({
        show: true,
        block_by: this.loggedInProfile.profile_id,
        block_to: this.group.admin.profile.id,
      });
    },
    leaveGroup(group) {
      this.loading = true;
      // await this.$store.dispatch("groups/leaveGroup");
      // this.$store.dispatch("snackBar/showSnack", {
      //   text: `Successfully left ${this.$store.state.groups.group.name}`,
      //   color: "success",
      //   timeout: 4500,
      // });
      const successHandler = (res) => {
        this.loading = false;

        this.isParticipantToggle({ state: false });
        console.log(res);
        this.eventBus.$emit("refresh-group-detail");
      };
      const failureHandler = () => {
        this.loading = false;
      };
      let formData = {};
      formData["membership_type"] = "left_membership";
      formData["group"] = group.id;
      formData["member"] = this.commonFun.getUserId();
      Axios.request_PATCH(
        "/api/join-leave/",
        formData,
        {},
        successHandler,
        failureHandler,
        false,
        true
      );
    },

    // async deleteGroup() {
    //   this.loading = true;
    //   const deleteConfirm = confirm("Are you sure you want to delete this group?");
    //   if (deleteConfirm) {
    //     await this.$store.dispatch("groups/deleteGroup");
    //     this.$store.dispatch("snackBar/showSnack", {
    //       text: `Successfully deleted ${this.$store.state.groups.group.name}`,
    //       color: "success",
    //       timeout: 4500,
    //     });
    //     this.$router.push({ name: "ProfilePage" });
    //   }
    //   this.loading = false;
    // },
    deleteGroup(group) {
      const deleteConfirm = confirm(
        "Are you sure you want to delete this group?"
      );
      if (deleteConfirm) {
        this.loading = true;
        const successHandler = () => {
          this.$store.dispatch("snackBar/showSnack", {
            text: `Successfully deleted ${this.$store.state.groups.group.name}`,
            color: "success",
            timeout: 4500,
          });
          this.loading = false;
          this.$router.push({ name: "ProfilePage" });
        };
        const failureHandler = () => {
          this.loading = false;
        };
        let formData = {};
        formData["id"] = group.id;
        newAxios("delete", "/api/group-detail/", {
          params: formData,
          onSuccess: successHandler,
          onFailure: failureHandler,
        });
      }
    },
    editGroup(group) {
      // console.log(group,"group")
      this.toggleGroupModal({ show: true, type: "edit", id: group.id });
    },

    shareGroup() {
      const userId = localStorage.getItem("user_id");
      const url = `${location.protocol}//${location.host}/groups/${this.group.id}?utm_source=user_${userId}&utm_medium=share_link`;
      const text = "Checkout this group on Covesto";
      const title = "Covesto";

      // if (!this.commonFun.isAuthenticated) {
      //   this.$router.push({ name: "login" });
      //   return;
      // }

      if (!navigator.canShare) {
        navigator.clipboard.writeText(
          `Covesto
          Checkout this group on Covesto.
          ${url}
          `
        );
      }
      helper.shareLink(url, text, title);
      // navigator.share(
      //   {
      //     title: "Covesto",
      //     text: `Checkout this group on Covesto.`,
      //     url: url,
      //   },
      //   {
      //     skype: false,
      //     pinterest: false,
      //     print: false,
      //     sms: false,
      //   }
      // );
    },
  },

  created() {
    this.eventBus.$on("leave-group", (value) => {
      this.leaveGroup(value.group);
      console.log("value", value);
    });
  },
  beforeDestroy() {
    this.eventBus.$off("leave-group");
  },
  mounted() {
    this.loggedInProfile["user_id"] = localStorage.getItem("user_id");
    this.loggedInProfile["profile_id"] = localStorage.getItem("profile_id");

    // this.$router.push({ name: "login" });
  },
};
</script>

<style scoped>
.share-btn {
  min-width: 36px !important;
  padding: 8px !important;
}
</style>
